import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "16",
      "stroke-width": "3"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-width": "3",
      d: "M32 8v8m0 40v-8m24-16h-8M8 32h8m32.97-16.97-5.66 5.66M15.03 48.97l5.66-5.66m28.28 5.66-5.66-5.66M15.03 15.03l5.66 5.66"
    }, null, -1)
  ])))
}
export default { render: render }